import { userDetails } from "../type";

const initialState = {
    userPersonalDetails: '',
    userBankDetails: '',
    userPersonalCheck: false,
    userBankCheck: false,
    depositOrders: [],
    withdrawOrders: [],
    ordersHistory: [],
    viewOrder: '',
    approvedTransaction: '',
    updatePersonalDetails: false,
    transactionByTransactionId: {
        votes: Number
    },
    passwordUpdate: false,
    userBanks: [],
    collateralSubmitted: false,
    addNewBank: false,
    regionCreated: false,
    regionBank: false,
    createOrder: {},
    confirmOrder: false,
    uploadVideo: false,
    userDepositOrders: [],
    userWithdrawOrders: [],
    userWalletDetails: [],
    depositOrderLoader: false,
    withdrawOrderLoader: false,
    historyLoader: false,
    settingsLoader: false,
    chatMessages: [],
    chatRoom: false,
    message: {},
    defaultBank: false,
    tickerData: [],
    changeLoginCredential: false,
    disputedDepositOrders: [],
    disputedWithdrawOrders: [],
    voteOrder: false,
    juryHistory: [],
    allOrders: [],
    custodianOrders: [],
    createOrderCheck: false,
    userUpdatedRole: false,
    profilePicture: '',
    editAvailability: false,
    userRewards: [],
    juryProofRecord: [],
    juryProofRequest: false,
    juryProofSubmit: false,
    openOrderDispute: false,
    changeDefaultBank: false,
    openOrderAppeal: false,
    voteAppealOrder: false,
    userBatchEarning: [],
    juryLiveOrders: [],
    appealedTransactions: [],
    appealedCompleteTransactions: [],
    custodianPortfolio: [],
    custodianDashboardData: {},
    userPortfolio: [],
    transactionLoader: false,
    buttonLoader: false,
    approvedLoader: false,
    userDashboardData: [],
    closeDisputeAfterJuryVotes: false,
    uploadProofDisputeOrAppeal: false,
    chatWithLoader: false,
    userBatchPortfolioData: [],
    userTotalTransfersData:{deposit: 0, withdrawn: 0,available:0,accured:0,batchAmount:0,earning:0 },
    custTotalBatches:{available:0,accured:0,batchAmount:0,earning:0 },
    custodianPoolDetail: {},
    rampValue: [],
    claimAvailable: false,
    getAllStaking: [],
    stakingDataLoader: false,
    cardsLoader:false,  
    socketInstance: {},
    chat: [],
    successMessage:false,
    earnings:[],
    balance:{},
    disputeLoader: false,
    countries: [],
    states: [],
    cities: [],

}

const UserDetails = (state = initialState, action) => {
    const { type, payload } = action;

    switch (type) {

        // case userDetails.SET_CHAT: {
        //     return {
        //         ...state,
        //         chat: payload
        //     }
        // }

        case userDetails.SET_SOCKET_INSTANCE: {
            // console.log('payload', payload)
            return {
              ...state,
              socketInstance: payload
            }
        }
        case userDetails.SET_USER_PERSONAL_DETAILS: {
            return {
                ...state,
                userPersonalDetails: payload,
            }
        }

        // case userDetails.SET_ALL_STAKING_DATA_COUNT: {
        //     return {
        //         ...state,
        //         stakeTxCount: payload,
        //     }
        // }

        case userDetails.SET_USER_BANK_DETAILS: {
            return {
                ...state,
                userBankDetails: payload,
            }
        }

        case userDetails.SET_USER_PERSONAL_CHECK: {
            return {
                ...state,
                userPersonalCheck: payload,
            }
        }

        case userDetails.SET_USER_BANK_CHECK: {
            return {
                ...state,
                userBankCheck: payload,
            }
        }

        case userDetails.SET_ALL_STAKING_LOADER: {
            return {
                ...state,
                userBankCheck: payload,
            }
        }

        case userDetails.SET_DEPOSIT_ORDERS: {
            return {
                ...state,
                depositOrders: payload,
            }
        }

        case userDetails.SET_WITHDRAW_ORDERS: {
            return {
                ...state,
                withdrawOrders: payload,
            }
        }

        case userDetails.SET_ORDERS_HISTORY: {
            return {
                ...state,
                ordersHistory: payload
            }
        }

        case userDetails.UPDATE_USER_PERSONAL_DETAILS: {
            return {
                ...state,
                updatePersonalDetails: payload,
            }
        }

        case userDetails.SET_VIEW_ORDER: {
            return {
                ...state,
                viewOrder: payload
            }
        }

        case userDetails.SET_APPROVED_TRANSACTION: {
            return {
                ...state,
                approvedTransaction: payload
            }
        }

        case userDetails.SET_TRANSACTION_BY_TRANSACTION_ID: {
            return {
                ...state,
                transactionByTransactionId: payload
            }
        }

        case userDetails.SET_USER_REWARDS: {
            return {
                ...state,
                userRewards: payload,
            }
        }

        case userDetails.SET_PASSWORD_UPDATE: {
            return {
                ...state,
                passwordUpdate: payload
            }
        }

        case userDetails.SET_USER_BANKS: {
            return {
                ...state,
                userBanks: payload
            }
        }

        case userDetails.SET_COLLATERAL_SUBMITTED: {
            return {
                ...state,
                collateralSubmitted: payload
            }
        }

        case userDetails.SET_ADD_NEW_BANK: {
            return {
                ...state,
                addNewBank: payload
            }
        }

        case userDetails.SET_CREATE_REGION: {
            return {
                ...state,
                regionCreated: payload
            }
        }

        case userDetails.SET_REGION_BANK: {
            return {
                ...state,
                regionBank: payload
            }
        }

        case userDetails.SET_CREATE_ORDER: {
            return {
                ...state,
                createOrder: payload
            }
        }

        case userDetails.SET_CREATE_ORDER_STATUS: {
            return {
                ...state,
                createOrderCheck: payload
            }
        }

        case userDetails.SET_CONFIRM_ORDER: {
            return {
                ...state,
                confirmOrder: payload
            }
        }

        case userDetails.SET_UPLOAD_VIDEO: {
            return {
                ...state,
                uploadVideo: payload
            }
        }

        case userDetails.SET_USER_DEPOSIT_ORDERS: {
            return {
                ...state,
                userDepositOrders: payload
            }
        }

        case userDetails.SET_USER_WITHDRAW_ORDERS: {
            return {
                ...state,
                userWithdrawOrders: payload
            }
        }

        case userDetails.SET_USER_WALLET_DETAILS: {
            return {
                ...state,
                userWalletDetails: payload
            }
        }

        case userDetails.SET_DEPOSIT_ORDER_LOADER: {
            return {
                ...state,
                depositOrderLoader: payload
            }
        }

        case userDetails.SET_WITHDRAW_ORDER_LOADER: {
            return {
                ...state,
                withdrawOrderLoader: payload
            }
        }

        case userDetails.SET_SETTINGS_LOADER: {
            return {
                ...state,
                settingsLoader: payload
            }
        }

        case userDetails.SET_HISTORY_LOADER: {
            return {
                ...state,
                historyLoader: payload
            }
        }

        case userDetails.SET_CHAT: {
            console.log("old state payload in redux", payload)
          
            const key = '_id';

            const arrayUniqueByKey = [...new Map([...state.chatMessages,...payload].map(item =>
              [item[key], item])).values()];
            console.log("we are setting this ", arrayUniqueByKey)

            return {
                ...state,
                chatMessages: arrayUniqueByKey
            }
        }

        case userDetails.SET_CHAT_ROOM: {
            return {
                ...state,
                chatRoom: payload
            }
        }

        case userDetails.SET_SEND_MESSAGE: {
            return {
                ...state,
                message: payload
            }
        }

        case userDetails.RESET_USER_STATE: {
            return initialState
        }

        case userDetails.SET_DEFAULT_BANK: {
            return {
                ...state,
                defaultBank: payload
            }
        }

        case userDetails.SET_TICKER_DATA: {
            return {
                ...state,
                tickerData: payload
            }
        }

        case userDetails.SET_CHANGE_LOGIN_CREDENTIAL: {
            return {
                ...state,
                changeLoginCredential: payload
            }
        }

        case userDetails.SET_DISPUTED_DEPOSIT_ORDERS: {
            return {
                ...state,
                disputedDepositOrders: payload
            }
        }

        case userDetails.SET_DISPUTED_WITHDRAW_ORDERS: {
            return {
                ...state,
                disputedWithdrawOrders: payload
            }
        }

        case userDetails.SET_ORDER_VOTE: {
            return {
                ...state,
                voteOrder: payload
            }
        }

        case userDetails.SET_JURY_HISTORY: {
            return {
                ...state,
                juryHistory: payload
            }
        }

        case userDetails.SET_ALL_ORDERS: {
            return {
                ...state,
                allOrders: payload
            }
        }

        case userDetails.SET_CUSTODIAN_ORDERS: {
            return {
                ...state,
                custodianOrders: payload
            }
        }

        case userDetails.SET_USER_UPDATED_ROLE: {
            return {
                ...state,
                userUpdatedRole: payload
            }
        }

        case userDetails.SET_USER_PROFILE_PICTURE: {
            return {
                ...state,
                profilePicture: payload
            }
        }

        case userDetails.SET_USER_AVAILABILITY: {
            return {
                ...state,
                editAvailability: payload
            }
        }

        case userDetails.SET_JURY_PROOF: {
            return {
                ...state,
                juryProofRecord: payload
            }
        }

        case userDetails.SET_JURY_PROOF_REQUEST: {
            return {
                ...state,
                juryProofRequest: payload
            }
        }

        case userDetails.SET_JURY_PROOF_SUBMIT: {
            return {
                ...state,
                juryProofSubmit: payload
            }
        }

        case userDetails.SET_OPEN_ORDER_DISPUTE: {
            return {
                ...state,
                openOrderDispute: payload
            }
        }

        case userDetails.SET_MAKE_DEFAULT_BANK: {
            return {
                ...state,
                changeDefaultBank: payload
            }
        }

        case userDetails.SET_OPEN_ORDER_APPEAL: {
            return {
                ...state,
                openOrderAppeal: payload
            }
        }

        case userDetails.SET_VOTE_APPEAL_ORDER: {
            return {
                ...state,
                voteAppealOrder: payload
            }
        }

        case userDetails.SET_USER_BATCH_EARNING: {
            return {
                ...state,
                userBatchEarning: payload
            }
        }

        case userDetails.SET_JURY_LIVE_ORDERS: {
            return {
                ...state,
                juryLiveOrders: payload
            }
        }

        case userDetails.SET_APPEALED_TRANSACTIONS: {
            return {
                ...state,
                appealedTransactions: payload
            }
        }

        case userDetails.SET_APPEALED_COMPLETE_ORDERS: {
            return {
                ...state,
                appealedCompleteTransactions: payload
            }
        }

        case userDetails.SET_CUSTODIAN_PORTFOLIO: {
            return {
                ...state,
                custodianPortfolio: payload
            }
        }

        case userDetails.SET_CUSTODIAN_DASHBOARD_DATA: {
            return {
                ...state,
                custodianDashboardData: payload
            }
        }

        case userDetails.SET_USER_PORTFOLIO: {
            return {
                ...state,
                userPortfolio: payload
            }
        }

        case userDetails.SET_TRANSACTION_BY_ID_LOADER: {
            return {
                ...state,
                transactionLoader: payload
            }
        }

        case userDetails.SET_BUTTON_LOADER: {
            return {
                ...state,
                buttonLoader: payload
            }
        }

        case userDetails.SET_DISPUTE_LOADER: {
            return {
                ...state,
                disputeLoader: payload
            }
        }

        case userDetails.SET_APPROVED_STATUS: {
            return {
                ...state,
                approvedLoader: payload,
            }
        }

        case userDetails.SET_USER_DASHBOARD_DATA: {
            return {
                ...state,
                userDashboardData: payload
            }
        }

        case userDetails.SET_CLOSE_DISPUTE_AFTER_JURY_VOTES: {
            return {
                ...state,
                closeDisputeAfterJuryVotes: payload
            }
        }

        case userDetails.SET_ADD_PROOF: {
            return {
                ...state,
                uploadProofDisputeOrAppeal: payload
            }
        }

        case userDetails.SET_CHAT_WITH_LOADER: {
            return {
                ...state,
                chatWithLoader: payload
            }
        }

        case userDetails.SET_USER_BATCH_PORTFOLIO_DATA: {
            return {
                ...state,
                userBatchPortfolioData: payload
            }
        }

        case userDetails.SET_USER_TOTAL_TRANSFERS: {
            return {
                ...state,
                userTotalTransfersData: payload
            }
        }
        case userDetails.SET_CUST_BATCHES: {
            return {
                ...state,
                custTotalBatches: payload
            }
        }

        case userDetails.SET_CUSTODIAN_POOL_AMOUNT: {
            return {
                ...state,
                custodianPoolDetail: payload
            }
        }

        case userDetails.SET_CUSTODIAN_RAMP_VALUE: {
            return {
                ...state,
                rampValue: payload
            }
        }
        
        case userDetails.SET_CUSTODIAN_EARNINGS_AMOUNT: {
            return {
                ...state,
                earnings: payload
            }
        }

        case userDetails.SET_CLAIM_AVAILABLE_AMOUNT: {
            return {
                ...state,
                claimAvailable: payload
            }
        }

        case userDetails.SET_ALL_STAKING_DATA: {
            return {
                ...state,
                getAllStaking: payload
            }
        }

        // Commented out since it was a duplicated case on line 141
        // case userDetails.SET_ALL_STAKING_LOADER: {
        //     return {
        //         ...state,
        //         stakingDataLoader: payload
        //     }
        // }

        case userDetails.SET_ALL_CARDS_LOADER: {
            return {
                ...state,
                cardsLoader: payload
            }
        }

        case userDetails.SUCCESS_MESSAGE: {
            return {
                ...state,
                successMessage: payload
            }
        }
        case userDetails.SET_USER_BALANCE: {
            return {
                ...state,
                balance: payload
            }
        }
        case userDetails.FETCH_COUNTRIES: {
            return {
                ...state,
                countries: action.payload
            }
        }

        case userDetails.FETCH_STATES: {
            return {
                ...state, 
                states: action.payload,
            }
        }

        case userDetails.FETCH_CITIES: {
            return {
                ...state,
                cities: action.payload,
            }
        }
        default: {
            return state;
        }
    }
};

export default UserDetails;
